<template>
  <b-row>
    <b-col
        cols="12"
        xl="9"
        lg="8"
        md="7"
    >
      <PersonCardInfo />
    </b-col>
    <b-col
        cols="12"
        md="5"
        xl="3"
        lg="4"
    >
     <PlanCardInfo />
    </b-col>
    <b-col
        cols="12"
        md="12"
        xl="12"
        lg="12"
    >
      <Beneficiaries />
    </b-col>
  </b-row>
</template>

<script>
import PersonCardInfo from "@/components/PersonCardInfo";
import PlanCardInfo from "@/components/PlanCardInfo";
import Beneficiaries from "@/components/Beneficiaries";
export default {
  components:{
    PersonCardInfo,
    PlanCardInfo,
    Beneficiaries
  }
}
</script>

<style>

</style>
